import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgFlag = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3 21.25V3"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 16.7549L5.55824 15.9681C6.61797 15.6418 7.73511 15.5454 8.83507 15.6853C9.93502 15.8251 10.9925 16.1981 11.9368 16.7792C12.8584 17.3472 13.8881 17.7171 14.9604 17.8654C16.0328 18.0137 17.1242 17.9371 18.1653 17.6406L20.5881 16.9479C20.7788 16.8934 20.9466 16.7783 21.066 16.6199C21.1855 16.4616 21.25 16.2686 21.25 16.0703V6.55837C21.2499 6.41718 21.217 6.27793 21.154 6.15158C21.091 6.02523 20.9995 5.91521 20.8868 5.83017C20.7741 5.74513 20.6432 5.68737 20.5044 5.66145C20.3656 5.63552 20.2227 5.64213 20.0869 5.68075L18.1653 6.22987C17.1246 6.52715 16.0333 6.60452 14.9609 6.45706C13.8886 6.3096 12.8587 5.94053 11.9368 5.37334C10.9925 4.79224 9.93502 4.4193 8.83507 4.27943C7.73511 4.13956 6.61797 4.23597 5.55824 4.56223L3 5.34819"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgFlag.displayName = 'SvgFlag';
export default SvgFlag;
